import { Component, OnDestroy } from '@angular/core';
import { SearchFilterSortService } from 'ng-searchfiltersort';
import { FunctionDesc, ElementAction, CustomAction } from '../../models/configuration.model';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { FunctionService } from '../../services/function/function.service';
import { ConfigurationStoreService } from '../../services/configuration-store/configuration-store.service';
import { ViewSelectorService } from '../../services/view-selector/view-selector.service';

@Component({
  selector: 'baf-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent implements OnDestroy {
  private isAlive = true;
  items: FunctionDesc[];

  constructor(
    configurationStore: ConfigurationStoreService,
    sfsService: SearchFilterSortService,
    private storeService: DataStoreService,
    private functionService: FunctionService,
    private viewSelector: ViewSelectorService
  ) {
    // TODO MK-REF Przenieść do usługi i udostępnić DataSource

    configurationStore.configurationStream
      .takeWhile(() => this.isAlive)
      .subscribe(configuration => {
        const menuFunctions = configuration.application.functions;
        this.items = this.storeService.sortFunction(menuFunctions);
        this.items = sfsService.orderBy(this.items, 'order');
      });
  }

  onItemClick(event: any) {
    const item = <FunctionDesc>event.itemData;
    const action = item.action as CustomAction;
    if (action && item.action) {
      this.selectViewForElementAction(action);
      this.functionService.callFunction(action.functionName, this.storeService.currentId, item);
    }
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  private selectViewForElementAction(action: CustomAction) {
    if (action.actionType === 'ElementAction') {
      const elementAction = action as ElementAction;
      const viewId = elementAction.elementId.substring(2);
      this.viewSelector.setActiveViewById(viewId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/top-menu/top-menu.component.ts